import { NgModule } from '@angular/core';
import { CatchEventsDirective } from './catch-events.directive';

@NgModule({
    imports: [],
    declarations: [CatchEventsDirective],
    exports: [CatchEventsDirective],
})
export class CatchEventsModule {}
